import { render, staticRenderFns } from "./bv-scroll.vue?vue&type=template&id=f4d6d96e"
import script from "./bv-scroll.vue?vue&type=script&lang=js"
export * from "./bv-scroll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../apps/gouwubao/node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports